export const industriesWeWorkTextContent = {
  headingText: "Industries We Work In",
  content: [
    {
      iconSrc: "/assets/stock-img/industries_we_work_img_01.webp",
      titleText: "Sports Betting",
      paraText: "Commencing from white label sportsbook software, custom sports betting software development, sports betting app to sports betting exchange software, we cover a comprehensive range of sports betting software solutions.",
    },
    {
      iconSrc: "/assets/stock-img/industries_we_work_img_02.webp",
      titleText: "Online Casinos",
      paraText: "Our detailed online casino software solutions cover engaging features, exciting casino games catalogue, powerful back office admin, casino management system and much more for enhancing growth of your online casino business.",
    },
    {
      iconSrc: "/assets/stock-img/industries_we_work_img_03.webp",
      titleText: "Live Dealer Casinos",
      paraText: "Whether you want to build live casino software from scratch or migrate your existing online casino business to live dealer casinos, we can be your perfect helping hands for your every requirement.",
    },
    {
      iconSrc: "/assets/stock-img/industries_we_work_img_04.webp",
      titleText: "Casino Game Development",
      paraText: "Along with ready to launch casino games such as Slots, Dice, Crash, etc, we also offer custom game development services for your specific requirements. We incorporate all the engaging game features in the casino games.",
    },
  ],
};
